module.exports = __webpack_public_path__ + "static/media/numbers_2.ac281888.svg";